import chunk from 'lodash/chunk';

export const gridMixin = {
  data() {
    return {
      groupedCollection: (items, columns) => {
        return chunk(items, columns);
      },
    };
  },
  methods: {
    getGridGroups(items, columns = 4) {
      return this.groupedCollection(items, columns);
    },
  },
};
